var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaleIdle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 445,
    fill: "none",
    viewBox: "0 0 156 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M84.5109 438.003C76.0705 430.469 22.6547 429.924 27.8532 419.246C79.3638 313.455 84.9641 106.612 76.7488 79.7573C72.5592 66.0623 77.4571 51.3467 90.6726 45.8164C103.891 40.2839 118.969 43.2628 125.794 55.8535C138.623 79.5171 187.039 302.942 125.165 430.014C118.891 442.897 103.352 448.259 90.4594 441.986C88.2505 440.913 86.2594 439.564 84.5109 438.003",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M104.545 439.803C102.334 438.727 100.343 437.378 98.5967 435.819C90.1547 428.283 37.1921 427.947 41.9372 417.06C107.723 266.146 91.4691 79.0936 90.8321 77.5724C85.4305 64.6408 91.2998 49.8328 103.939 44.0209C99.5789 43.4693 95.0208 43.996 90.6723 45.8164C77.4572 51.3467 71.2276 66.5424 76.7485 79.7573C77.3858 81.2801 96.9502 219.786 27.8533 419.246C23.9659 430.467 76.0705 430.469 84.511 438.003C86.2595 439.564 88.2502 440.913 90.4592 441.986C97.7517 445.532 105.887 445.355 112.716 442.203C109.95 441.861 107.19 441.089 104.545 439.803",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M24.4436 68.7243C20.3317 65.0536 18.873 59.0072 21.2601 53.7171L31.6733 30.6352C33.7714 25.9841 38.4021 22.9948 43.5065 22.9916L84.4783 22.991C91.6445 22.991 97.4579 28.8006 97.4595 35.9607C97.4614 43.1242 91.6489 48.9364 84.4796 48.9348L51.8942 48.9386L44.9292 64.3816C41.9825 70.9134 34.2949 73.8194 27.7606 70.8768C26.5186 70.3178 25.4074 69.5847 24.4436 68.7243",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M69.5402 105.394C97.1203 114.656 140.239 113.934 134.806 87.1693C125.944 43.5034 103.96 4.85598 76.4433 6.57034C76.4433 6.57034 60.8478 22.692 58.678 40.1006C87.8977 74.4565 69.5402 105.394 69.5402 105.394",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M83.7754 73.6982C82.3398 63.7441 71.824 44.0783 58.6777 40.1007C87.8977 74.4563 69.5403 105.394 69.5403 105.394C76.5205 107.738 86.4663 92.4062 83.7754 73.6982",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M4.36234 72.8072C1.81423 70.5323 0.165179 67.2652 0.0338105 63.5856C-0.128821 58.9554 -0.748085 17.9778 27.2899 4.95697C53.5835 -7.25118 83.6448 6.85722 84.9114 7.46349C91.3775 10.5621 94.1091 18.3086 91.009 24.7708C87.9174 31.2195 80.1888 33.9508 73.7318 30.8819C68.0943 28.2421 50.7474 22.6749 38.2267 28.4874C28.3273 33.0854 25.6715 53.8896 25.9822 62.6722C26.2349 69.8329 20.6293 75.8433 13.4665 76.0929C9.98181 76.2176 6.76992 74.9564 4.36234 72.8072",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M12.6603 71.7818C10.1132 69.5079 8.46223 66.2407 8.33402 62.5592C8.17013 57.9309 7.54992 16.9524 35.5889 3.93254C39.5148 2.1071 43.5259 0.882873 47.5121 0.10144C40.8821 0.459018 33.9673 1.85619 27.2899 4.95699C-0.748085 17.9778 -0.128821 58.9554 0.0338105 63.5856C0.165179 67.2652 1.81392 70.5323 4.36234 72.8072C6.76992 74.9564 9.98181 76.2176 13.4665 76.0929C15.3461 76.027 17.1041 75.5469 18.691 74.7724C16.416 74.3057 14.3365 73.2781 12.6603 71.7818",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M82.0304 29.8574C77.0258 27.5138 62.7934 22.8807 50.9011 25.937C60.4632 25.8771 69.8599 29.0703 73.7318 30.8819C77.4315 32.6379 81.5415 32.4852 84.9638 30.8314C83.9728 30.6234 82.9875 30.3116 82.0304 29.8574",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M83.6991 14.9224C73.2556 12.5185 38.0767 6.61356 22.0122 15.2365C13.322 20.1734 6.98944 27.7072 3.18291 37.0765C-0.241193 49.6608 -0.0482454 61.2504 0.0338599 63.5856C0.165228 67.2655 1.81397 70.5323 4.36239 72.8072C6.76997 74.9564 9.98186 76.2176 13.4666 76.0929C19.1208 75.8963 23.7512 72.0873 25.3501 66.9843C24.3241 58.6041 25.1533 51.5078 27.7352 46.2006C29.5018 38.5229 32.7557 31.0276 38.2267 28.4874C50.7471 22.6749 68.0944 28.2421 73.7319 30.8818C80.1888 33.9508 87.9171 31.2195 91.0087 24.7708C91.729 23.2651 92.1241 21.6921 92.2403 20.122C90.1599 17.475 87.1829 15.53 83.6991 14.9224",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M8.96587 92.7013C7.01176 90.957 5.56513 88.6095 4.95092 85.8594C-1.46118 57.1423 6.41177 33.3247 26.0116 22.1464C41.9014 13.0813 74.9854 15.8918 84.7471 16.9689C91.8754 17.7542 97.014 24.1675 96.2267 31.2859C95.4385 38.4081 89.0254 43.5443 81.9003 42.7584C65.8304 41.0015 44.712 41.353 38.8787 44.6808C29.5654 49.993 26.4344 62.9409 30.2889 80.2072C31.8502 87.1981 27.4437 94.1335 20.4473 95.6929C16.2025 96.64 11.9794 95.3915 8.96587 92.7013",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBC399",
    fillRule: "evenodd",
    d: "M22.7244 114.131C18.8127 110.639 17.2612 104.964 19.2602 99.7851C21.8345 93.1092 29.3291 89.7811 36.0096 92.334C41.2751 94.3287 57.3924 98.7566 68.6136 95.3029C79.5709 91.9313 84.2923 77.2473 84.3362 77.0986C86.3392 70.2213 93.5443 66.264 100.428 68.2681C107.307 70.2766 111.266 77.4707 109.266 84.3506C108.931 85.4975 100.796 112.548 76.251 120.1C54.4492 126.81 29.4788 117.624 26.7024 116.555C25.1967 115.976 23.8609 115.145 22.7244 114.131",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA9975",
    fillRule: "evenodd",
    d: "M18.6641 106.612C18.6641 106.612 18.8128 110.639 22.7242 114.13C23.8607 115.145 25.1968 115.976 26.7022 116.555C29.4786 117.624 54.449 126.81 76.2508 120.1C79.6942 119.043 82.8012 117.59 85.6234 115.889C64.1128 121.912 26.4473 116.679 18.6641 106.612",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M134.189 124.848L138.787 131.883"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M112.447 113.938L110.953 122.208"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M121.329 136.259L122.473 144.585"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M135.426 192.01L136.57 200.335"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M113.195 342.344L111.802 350.631"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M151.16 233.991L152.305 242.316"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M128.518 329.95L129.662 338.275"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M138.624 220.745L141.059 228.789"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M128.869 262.124L131.305 270.167"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M142.627 346.628L145.063 354.672"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M143.845 277.561L146.28 285.604"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M150.016 206.27L151.16 214.595"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M129.042 164.884L127.256 173.096"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M122.429 207.934L120.644 216.146"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M114.284 313.872L112.499 322.084"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M83.5993 338.275L81.8145 346.488"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M113.391 286.351L111.606 294.563"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M109.509 257.934L107.724 266.146"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M94.1489 296.229L89.9053 303.484"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M127.117 237.011L127.967 245.371"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M129.237 294.026L130.087 302.387"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M108.763 146.228L104.063 153.196"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M97.6008 134.416L92.9009 141.384"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M114.701 186.539L111.47 194.297"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M98.1861 319.846L94.9546 327.604"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M102.602 213.564L96.9504 219.786"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M112.498 165.208L107.798 172.177"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M108.585 234.67L103.885 241.638"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M94.3769 267.978L89.677 274.946"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M98.9201 189.645L94.2202 196.613"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M91.1008 239.713L86.4006 246.681"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M95.5531 166.398L88.5012 170.975"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M136.965 147.548L140.916 154.966"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M143.845 177.062L147.796 184.48"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M139.083 318.375L143.035 325.793"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M145.821 254.225L149.772 261.643"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M149.757 302.387L153.708 309.805"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M23.3711 101.048L35.1241 104.474C36.4148 104.843 37.5734 105.572 38.4646 106.575H38.4649C41.4706 109.957 40.5693 115.25 36.6137 117.448L35.8741 117.859"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EA9975",
    strokeLinecap: "round",
    strokeWidth: 1.895,
    d: "M19.5489 92.9673L18.9423 84.3043C18.875 82.9245 18.4162 81.592 17.6194 80.4634C14.9333 76.6566 9.41082 76.316 6.27661 79.7637L5.69019 80.4082"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIdle);
export default __webpack_public_path__ + "static/media/male_idle.1f4203a2e4fb33411e90198e46b08407.svg";
export { ForwardRef as ReactComponent };